import pipe from 'ramda/src/pipe';
import prop from 'ramda/src/prop';
import ifElse from 'ramda/src/ifElse';
import isNil from 'ramda/src/isNil';
import useUser from '../use-user';

const useFilters = (onBoardingFilters, localStoragePointer) => {
  const { user } = useUser();

  const getFilters: () => { needs: string[], filter: string } = () => {
    const filtersFromStorage = localStorage.getItem(localStoragePointer);
    return filtersFromStorage
      ? JSON.parse(filtersFromStorage)
      : ifElse(isNil, () => ({ needs: [] }), pipe(prop('needs'), (needs: string[]) => ({
        needs: needs ? needs?.filter((need) => onBoardingFilters.needs.includes(need)) : [],
      })))(user);
  };
  return {
    getFilters,
  };
};

export default useFilters;
